import React, { memo } from "react";
import { css } from "@emotion/core";
import WithStyles from "shared/components/WithStyles";

const menuItemCss = css`
    position: relative;
    margin-bottom: 24px;
    padding-left: 30px;
    cursor: pointer;

    .icon {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

interface IMenuItemProps {
    iconClassName: string;
    title: string;
    onClick: VoidFunction;
}

function MenuItem({ iconClassName, title, onClick }: IMenuItemProps) {
    const iconCss = `icon ${iconClassName ? iconClassName : ""}`;

    return (
        <WithStyles role="button" aria-label={title} cssProps={menuItemCss} onClick={onClick}>
            <i className={iconCss} />
            {title}
        </WithStyles>
    );
}

export default memo(MenuItem);
